import PageLayout from "../components/layout/PageLayout";
import GroupList from "components/lists/groups/GroupList";

export default function AdditionalItemsPage() {
  return (
    <PageLayout
      pageTitle="Grupos de artículos"
      pageDesc="Altas, bajas y modificaciones."
    >
      <GroupList />
    </PageLayout>
  );
}
